'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import Image from 'next/image';
import { useState } from 'react';
import { RegionFinderDialog } from './RegionFinderDialog';
interface RegionFinderEntryProps {
  className?: string;
}
export const RegionFinderEntry = t0 => {
  const $ = _c(11);
  const {
    className
  } = t0;
  const [isDialogOpened, setIsDialogOpened] = useState(false);
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full px-40 content-container", "mobile-tablet:px-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("group flex h-56 w-full items-center justify-center gap-16 rounded-medium px-16", "border border-O-100 bg-O-25 hover:bg-O-50 active:bg-O-100", "transition-colors duration-150 motion-reduce:transition-none", FOCUS_RING);
    t3 = () => setIsDialogOpened(true);
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <button className={t2} onClick={t3}><span className="flex min-w-0 items-center gap-8"><Image src="/assets/pngs/region-finder-pin.png" alt="" width={20} height={20} className="shrink-0" /><span className="truncate font-600 text-Gray-800 typo-body4">지역별 답례품 찾기</span></span><SvgChevronright className="size-14 shrink-0 text-Gray-800 transition-transform duration-150 group-hover:translate-x-1 group-focus-visible:translate-x-1 motion-reduce:transition-none" /></button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsDialogOpened(false);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isDialogOpened) {
    t6 = <RegionFinderDialog opened={isDialogOpened} onClose={t5} />;
    $[6] = isDialogOpened;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t1 || $[9] !== t6) {
    t7 = <div className={t1}>{t4}{t6}</div>;
    $[8] = t1;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};